// ProtectedRoute.tsx
import { useAuth } from "@/context/auth-context";
import LoginPage from "@/pages/auth/login";
import { fetchCategories } from "@/store/features/category-slice";
import { fetchCourses } from "@/store/features/course-slice";
import { fetchLevels } from "@/store/features/level-slice";
import { AppDispatch } from "@/store/store";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const { isAuthenticated, loading } = useAuth();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  // TODO: fetch the common data here

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(
        fetchCategories({
          params: {
            filters: {
              parent: {
                $null: true,
              },
            },
          },
        })
      );

      dispatch(fetchCourses({}));

      dispatch(fetchLevels({}));
    }
  }, [dispatch, isAuthenticated]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    // if (isAuthenticated) {
    // TODO: change this to !isAuthenticated
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <LoginPage />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);

    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
